import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const ABOUT_IMG = 'https://cdn.magicpatterns.com/uploads/cGrBZu93equr27XKf7Kq1W/lukman-hidayah-ZYcTVAOzxgA-unsplash.jpg';
export function About() {
  const bullets = ['Free and affordable government resources', 'Inclusive, community-first approach', 'Live appointment-based service', 'Multiple national locations'];
  return <section id="about" className="bg-brand-offblack py-16 md:py-24 relative" data-id="element-13">
      <div className="absolute inset-0 film-grain z-0" data-id="element-14" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-15">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-16">
          {/* Image Column */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="relative order-2 lg:order-1 px-4 lg:px-0" data-id="element-17">
            <div className="relative overflow-hidden border-2 border-brand-concrete" data-id="element-18">
              <img src={ABOUT_IMG} alt="Community outreach" className="w-full h-auto object-cover aspect-[4/3] lg:aspect-auto lg:h-[600px] grayscale" data-id="element-19" />
              <div className="absolute inset-0 bg-brand-black/20 mix-blend-overlay" data-id="element-20"></div>
            </div>

            {/* Floating Badge */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.8
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.4,
            type: 'spring'
          }} className="absolute -bottom-6 -right-2 lg:-right-6 bg-brand-lime text-brand-black font-mono font-bold py-3 px-6 border-2 border-brand-black" data-id="element-21">
              EST. 2009
            </motion.div>
          </motion.div>

          {/* Content Column */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="order-1 lg:order-2 flex flex-col" data-id="element-22">
            <p className="text-brand-lime font-mono font-bold tracking-widest uppercase text-sm mb-4" data-id="element-23">
              Who We Are
            </p>
            <h2 className="text-brand-soft text-[44px] md:text-[60px] leading-[0.95] font-display mb-6 uppercase" data-id="element-24">
              A Resource Center for Every Household
            </h2>
            <p className="text-brand-soft/80 text-base md:text-lg mb-8 leading-relaxed font-sans" data-id="element-25">
              Prime Nation stands as a comprehensive resolution center,
              dedicated to delivering free and affordable government resources
              to communities across the country. Our commitment goes beyond
              essential services. We actively foster a diverse, inclusive
              workforce and run impactful outreach programs that put real tools
              in real hands. Since 2009, we've proudly led the way, treating
              every person who walks through our doors with respect, dignity,
              and the service they deserve.
            </p>

            <ul className="space-y-4 mb-10" data-id="element-26">
              {bullets.map((bullet, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-27">
                  <ArrowRight className="text-brand-lime shrink-0 mt-0.5" size={20} data-id="element-28" />
                  <span className="text-brand-soft font-sans" data-id="element-29">{bullet}</span>
                </li>)}
            </ul>

            <div data-id="element-30">
              <button className="w-full md:w-auto bg-brand-lime text-brand-black px-8 py-4 font-mono font-bold text-sm uppercase tracking-widest hover:bg-white transition-colors min-h-[52px]" data-id="element-31">
                Learn More About Us
              </button>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}